import { DataBean } from "../DataBean";

export class ProductCost extends DataBean {
  public async getProductCostHistory(
    productID: any,
    storeID: any,
    from: any,
    upto: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getProductCostHistory_Number_Number_java.util.Date_java.util.Date",
      [productID, storeID, from, upto]
    );
  }

  public async addProductCost(
    productID: any,
    productCost: any,
    from: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "inventory.ProductCost_addProductCost_Number_Number_java.util.Date",
      [productID, productCost, from]
    );
  }

  public async deleteProductCost(idCost: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deleteProductCost_Number",
      [idCost]
    );
  }

  public async parseNewProductCostForDocument(idDocument: number, documentDate: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "boolean_parseNewProductCostForDocument_Number_java.util.Date",
      [idDocument, documentDate]
    );
  }

  public async getProductCostForProduct(productID: number, idStore: number, date: any, validateQuantities: boolean): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "inventory.ProductCost_getProductCostForProduct_Number_Number_java.util.Date_Boolean",
      [productID, idStore, date, validateQuantities]
    );
  }

  public async parseReCostForProduct(idProduct: number, from: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "boolean_parseReCostForProduct_Number_java.util.Date",
      [idProduct, from]
    );
  }

  public async updateProductCost(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "inventory.ProductCost_updateProductCost_inventory.ProductCost",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "inventory.ProductCost",
        },
      ]
    );
  }
}
